<template>
  <!-- Begin Widget.registerCourse -->
  <div class="form angebote anmeldung pWidget" :data-course-id="eventId">
    <div v-if="responseError">
      <p-request-alert v-model="responseError"></p-request-alert>
    </div>
    <div v-else-if="isLoading">
      <p-progress-linear indeterminate></p-progress-linear>
    </div>
    <div v-else-if="!course">
      <h3>{{ $t('widget.events.notFound') }}</h3>
      <p-row>
        <p-col>
          <p-request-alert v-model="responseError"></p-request-alert>
        </p-col>
      </p-row>
    </div>
    <div v-else-if="isRegisterSuccess">
      <p-alert type="success" :value="true">
        <span v-html="$t('widget.events.registerSuccess', course.name, $format.localDate(course.startDate))"></span>
      </p-alert>
    </div>
    <p-form v-else no-summary :model="model">
      <div class="listing">
        <div class="section-coursename">
          <h1>{{ course.name }}</h1>
        </div>
        <div class="section-personalinfo">
          <h4>{{ $t('widget.events.sectionPersonalData') }}</h4>
          <p-row dense>
            <p-col xs12>
              <p-row>
                <p-radio-field v-model="model.contactAddress.salutation" :true-value="0" name="gender" :label="$t('widget.events.genderEnum.0')"></p-radio-field>
                <p-radio-field v-model="model.contactAddress.salutation" :true-value="1" name="gender" :label="$t('widget.events.genderEnum.1')"></p-radio-field>
              </p-row>
            </p-col>
            <p-col xs12 sm6>
              <p-text-field v-model="model.contactAddress.firstName" :label="$t('widget.events.firstName')"></p-text-field>
            </p-col>
            <p-col xs12 sm6>
              <p-text-field v-model="model.contactAddress.lastName" :label="$t('widget.events.lastName')"></p-text-field>
            </p-col>
            <p-col xs12>
              <p-text-field v-model="model.contactAddress.street" :label="$t('widget.events.street')"></p-text-field>
            </p-col>
            <p-col xs12 sm3>
              <p-select
                v-model="model.contactAddress.countryId"
                :loading="isLoading"
                item-key="details"
                :label="$t('widget.events.country')"
                :items="countries"
              ></p-select>
            </p-col>
            <p-col xs4 sm1>
              <p-text-field v-model="model.contactAddress.postalCode" :label="$t('widget.events.postalCode')"></p-text-field>
            </p-col>
            <p-col xs8 sm8>
              <p-text-field v-model="model.contactAddress.city" :label="$t('widget.events.city')"></p-text-field>
            </p-col>
            <p-col xs6>
              <p-date-field v-model="model.contactAddress.dateOfBirth" :label="$t('widget.events.dateOfBirth')" :messages="$t('widget.events.dateOfBirth.message')"></p-date-field>
            </p-col>
          </p-row>
          <p-divider class="mt-3 pt-6"></p-divider>
        </div>
        <div class="section-communication">
          <p-row dense>
            <p-col xs12>
              <h4>{{ $t('widget.events.sectionCommunication') }}</h4>
            </p-col>
            <p-col xs12 sm6>
              <p-phone-field v-model="model.contactAddress.mobilePhoneNumber" :label="$t('widget.events.mobilePrivate')"></p-phone-field>
            </p-col>
            <p-col xs12 sm6>
              <p-phone-field v-model="model.contactAddress.phoneNumber" :label="$t('widget.events.phonePrivate')"></p-phone-field>
            </p-col>
            <p-col xs12 sm6>
              <p-text-field v-model="model.contactAddress.eMail" type="email" :label="$t('widget.events.eMail')"></p-text-field>
            </p-col>
          </p-row>
          <p-row dense>
            <p-col xs12>
            &nbsp;
            </p-col>
            <p-col xs12 sm6 class="field-addressCorrespondence">
              <p-col xs12>
                <h5>{{ $t('widget.events.sectionCorrespondenceAddress') }}</h5>
                <sup>{{ $t('widget.events.memberPriceInfo') }}</sup>
                <p-row dense>
                  <p-radio-field v-model="model.correspondenceAddress.isDifferent" :true-value="false" name="correspondence" :label="$t('widget.events.privateAddress')"></p-radio-field>
                  <p-radio-field v-model="model.correspondenceAddress.isDifferent" :true-value="true" name="correspondence" :label="$t('widget.events.institutionAddress')"></p-radio-field>
                </p-row>
              </p-col>
            </p-col>
            <p-col xs12 sm6 class="field-addressInvoice">
              <p-col xs12>
                <h5>{{ $t('widget.events.sectionInvoiceAddress') }}</h5>
                <sup>&nbsp;</sup>
                <p-row dense>
                  <p-radio-field v-model="model.invoiceAddress.isDifferent" :true-value="false" name="invoice" :label="$t('widget.events.privateAddress')"></p-radio-field>
                  <p-radio-field v-model="model.invoiceAddress.isDifferent" :true-value="true" name="invoice" :label="$t('widget.events.institutionAddress')"></p-radio-field>
                </p-row>
              </p-col>
            </p-col>
          </p-row>
          <p-divider class="mt-3 pt-6"></p-divider>
        </div>
        <template v-if="model.correspondenceAddress.isDifferent || model.invoiceAddress.isDifferent">
          <p-form no-summary :model="institutionModel" :schema="model.schemaInstitution">
            <div class="listing">
              <div>
                <p-row dense>
                  <p-col xs12>
                    <h4>{{ $t('widget.events.sectionInstitution') }}</h4>
                  </p-col>
                  <p-col xs12>
                    <p-text-field v-model="institutionModel.companyName" :label="$t('widget.events.companyName')"></p-text-field>
                  </p-col>
                  <p-col xs12>
                    <p-text-field v-model="institutionModel.street" :label="$t('widget.events.street')"></p-text-field>
                  </p-col>
                  <p-col xs12 sm3>
                    <p-select
                      v-model="institutionModel.countryId"
                      :loading="isLoading"
                      item-key="details"
                      :label="$t('widget.events.country')"
                      :items="countries"
                    ></p-select>
                  </p-col>
                  <p-col xs4 sm1>
                    <p-text-field v-model="institutionModel.postalCode" :label="$t('widget.events.postalCode')"></p-text-field>
                  </p-col>
                  <p-col xs8 sm8>
                    <p-text-field v-model="institutionModel.city" :label="$t('widget.events.city')"></p-text-field>
                  </p-col>
                  <p-col xs12 sm6>
                    <p-phone-field v-model="institutionModel.phoneNumber" :label="$t('widget.events.phoneBusiness')"></p-phone-field>
                  </p-col>
                  <p-col xs12 sm6>
                    <p-text-field v-model="institutionModel.eMail" :label="$t('widget.events.eMail')"></p-text-field>
                  </p-col>
                </p-row>
              </div>
            </div>
            <p-divider class="mt-3 pt-6"></p-divider>
          </p-form>
        </template>
        <template v-if="specificQuestionsFormDefinition && specificQuestionsFormDefinition.length > 0">
          <div class="section-specificquestions">
            <p-row dense>
              <p-col xs12>
                <h4>{{ $t('widget.events.sectionSpecificQuestions') }}</h4>
              </p-col>
              <p-col xs12>
                <p-progress-linear v-if="!specificQuestionsFormDefinition" indeterminate></p-progress-linear>
                <p-form :model="model.registrationAnswers">
                  <p-dynamic-form
                    v-model="model.registrationAnswers"
                    no-contact-fields
                    no-address-fields
                    :summary.sync="model.registrationAnswersSummary"
                    :form-definition="specificQuestionsFormDefinition"
                    :json-schema.sync="model.registrationAnswers.schema"
                  ></p-dynamic-form>
                </p-form>
              </p-col>
            </p-row>
            <p-divider class="mt-3 pt-6"></p-divider>
          </div>
        </template>
        <div class="section-additionalinformation">
          <p-row dense>
            <p-col xs12>
              <h4>{{ $t('widget.events.sectionAdditionalInformation') }}</h4>
            </p-col>
            <p-col xs12>
              <p-textarea v-model="model.comment" :placeholder="$t('widget.events.comment')" :label="$t('widget.events.comment')"></p-textarea>
            </p-col>
          </p-row>
          <p-divider class="newsletter mt-3 pt-6"></p-divider>
        </div>
        <div class="newsletter">
          <p-row dense>
            <p-col xs12>
              <p-checkbox v-model="model.acceptNewsletter" :label="$t('widget.events.acceptNewsletter')"></p-checkbox>
            </p-col>
          </p-row>
          <p-divider class="toc mt-3 pt-6"></p-divider>
        </div>
        <div class="toc">
          <p-row dense>
            <p-col xs12 justify-end>
              <p-checkbox v-model="model.acceptGdpr" label="Slot">
                <span v-html="$tAlt('widget.events.agb', undefined, { linkAGB: $config.getValueTranslated('widget-tocco-redirect-agb', {}), linkPrivacy: $config.getValueTranslated('widget-tocco-redirect-privacy', {}) })"></span>
              </p-checkbox>
            </p-col>
            <p-col xs12 justify-end>
              <p-button :disabled="isSending" :loading="isSending" @click="sendForm">
                {{ $t('widget.events.register') }}
              </p-button>
            </p-col>
          </p-row>
        </div>
      </div>
    </p-form>
  </div>
  <!-- End Widget.registerCourse -->
</template>

<script lang="ts">
  import Vue from 'vue';
  import WidgetSearchEventRequestViewModel from '../../../../services/v1/viewModel/resource/WidgetSearchEventRequestViewModel';
  import ApiPagingRequestViewModel from '../../../../services/v1/viewModel/resource/ApiPagingRequestViewModel';
  import WidgetClassListResourceViewModel from '../../../../services/v1/viewModel/resource/WidgetEventListResourceViewModel';
  import ContactAddressResourceViewModel from '../../../../services/v1/viewModel/resource/ContactAddressResourceViewModel';
  import RegisterClassRequestViewModel from '../../../../services/v1/viewModel/resource/RegisterEventRequestViewModel';
  import Int64LookupResourceViewModel from '../../../../services/v1/viewModel/resource/Int64LookupResourceViewModel';

  export default Vue.extend({
    layout: 'layout-widget',
    props: {
      submitRedirectUrl: { default: undefined, type: String },
    },
    data: () => ({
      isRegisterSuccess: false,
      isSending: false,
      isLoading: true,
      specificQuestionsFormDefinition: undefined as any,
      institutionModel: new ContactAddressResourceViewModel(),
      model: new RegisterClassRequestViewModel().fromDTO({
        contactAddress: {},
        correspondenceAddress: { contactAddress: { }, isDifferent: false },
        invoiceAddress: { contactAddress: { }, isDifferent: false },
        registrationAnswers: { },
      } as any),
      eventId: undefined as undefined | number,
      course: new WidgetClassListResourceViewModel(),
      responseError: undefined as any,
      countries: [] as Int64LookupResourceViewModel[],
      search: undefined as string | undefined,
    }),
    computed: {
      innerSubmitRedirectUrl(): string {
        if (this._.isSet(this.submitRedirectUrl)) {
          return this.submitRedirectUrl;
        }
        if (this.$config.values['widget-submitredirecturl']) {
          return this.$config.values['widget-submitredirecturl'];
        }
        const queries = this.$routerUtils.getQueryParams();
        return queries.submitRedirectUrl as string;
      },
    },
    watch: {
      'model.correspondenceAddress.isDifferent': {
        handler() {
          if (!this.model.correspondenceAddress.isDifferent) {
            this.model.correspondenceAddress.contactAddress = new ContactAddressResourceViewModel();
          } else {
            this.updateFromInstitutionModel();
          }
        },
      },
      'model.invoiceAddress.isDifferent': {
        handler() {
          if (!this.model.invoiceAddress.isDifferent) {
            this.model.invoiceAddress.contactAddress = new ContactAddressResourceViewModel();
          } else {
            this.updateFromInstitutionModel();
          }
        },
      },
      institutionModel: {
        deep: true,
        handler() {
          this.updateFromInstitutionModel();
        },
      },
    },
    async mounted() {
      const pp = this.$routerUtils.getQueryParams();
      const eventid = this.$config.values['widget-eventid'] ?? this.$route.params.eventid ?? pp.eventid;
      if (this._.isSet(eventid)) {
        this.eventId = Number.parseInt(eventid, 10);
        if (!Number.isNaN(this.eventId)) {
          await this.loadEventInformation();
        } else {
          this.responseError = `${this.$t('widget.events.invalidEventNumber')}: ${pp.eventid}`;
        }
      } else {
        this.responseError = this.$t('widget.events.noEventNumberSpecified');
        this.$log.error('No eventId given');
      }
    },
    methods: {
      updateFromInstitutionModel() {
        this.institutionModel.isCompany = true;
        if (!this.institutionModel.countryId) {
          this.institutionModel.countryId = this.countries.find((x) => x.details === 'CH')?.id;
        }
        if (this.model.correspondenceAddress.isDifferent) {
          this.model.correspondenceAddress.contactAddress = this.institutionModel;
        }
        if (this.model.invoiceAddress.isDifferent) {
          this.model.invoiceAddress.contactAddress = this.institutionModel;
        }
      },
      async sendForm() {
        this.model.eventId = this.eventId!;
        if (this.model.correspondenceAddress.isDifferent || this.model.invoiceAddress.isDifferent) {
          // Needs different schema since it's not the same model
          if (!this.institutionModel.validateWithSchema(this.model.schemaInstitution)) {
            return;
          }
        }
        const validateResultMode = this.model.validate();
        const validateResultRegiAnswers = this.model.registrationAnswers.validate();
        if (!validateResultMode || !validateResultRegiAnswers) {
          return;
        }
        this.isSending = true;
        try {
          this.model.languageIso2 = this.$translation.get()?.toLowerCase();
          this.model.contactAddress.countryIso2 = this.countries.find((x) => x.id === this.model.contactAddress.countryId)?.details;
          if (this.institutionModel.countryId) {
            this.institutionModel.countryIso2 = this.countries.find((x) => x.id === this.institutionModel.countryId)?.details;
          }
          await this.$service.v1.api.widgetEvents.widgetRegisterForEvent(this.eventId!, this.model);
          if (this.innerSubmitRedirectUrl !== undefined && this.innerSubmitRedirectUrl !== '') {
            window.location.href = this.innerSubmitRedirectUrl;
          }
        } catch (e: any) {
          this.$log.error(e);
          this.responseError = e;
        }
        this.isRegisterSuccess = true;
        this.isSending = false;
      },
      async loadDynamicForms() {
        const responseSpecific = await this.$service.v1.api.widgetEvents.getWidgetEventRegistrationQuestions(this.eventId!);
        this.specificQuestionsFormDefinition = responseSpecific.items;
        const countries = await this.$service.v1.api.widgetEvents.getWidgetCountries();
        this.countries = countries.items;
        if (!this.model.contactAddress.countryId) {
          this.model.contactAddress.countryId = this.countries.find((x) => x.details === 'CH')?.id;
        }
      },
      async loadEventInformation() {
        this.isLoading = true;
        await this.$guards.waitForAppLoad();
        try {
          const widgetSearchClassRequestVM = new WidgetSearchEventRequestViewModel();
          widgetSearchClassRequestVM.toccoFilter = `(pk == long:"${this.eventId}")`;
          const page = new ApiPagingRequestViewModel();
          page.pageSize = 1;
          widgetSearchClassRequestVM.paging = page;
          const response = await this.$service.v1.api.widgetEvents.getWidgetEvents(widgetSearchClassRequestVM);
          [this.course] = response.items.filter((i) => i.id === this.eventId);
          await this.loadDynamicForms();
        } catch (e : any) {
          this.responseError = e;
          this.$log.error(e);
        }
        this.isLoading = false;
      },
    },
  });
</script>

<style scoped lang="scss">

  .listing > * {
    padding-top: 12px;
    padding-bottom: 12px;
  }

</style>
